// ComplexCartModal.tsx
import React from "react";
import { useTheme } from "../../hooks/useTheme";
import { useComplexCartModal } from "./useComplexCartModal";
import ComplexCartStage from "./components/ComplexCartStage";
import ComplexOrderFields from "./components/ComplexOrderFields";
import ComplexOrderFooter from "./components/ComplexOrderFooter";
import styles from "./ComplexCartModal.module.scss";
import Button from "../button/Button";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";

interface ComplexCartModalProps {
  onClose: () => void;
}

export default function ComplexCartModal({ onClose }: ComplexCartModalProps) {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [stage, setStage] = React.useState<"cart" | "checkout" | "success">(
    "cart",
  );
  const [orderNumber, setOrderNumber] = React.useState<string>("");

  const {
    fieldsByCategory,
    fieldValues,
    phone,
    comment,
    loading,
    disabled,
    error, // 👈 Достаем ошибку
    setPhone,
    setComment,
    handleFieldChange,
    handleSend,
    groupedItems,
  } = useComplexCartModal((id) => {
    setOrderNumber(id);
    setStage("success");
  });

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.background }}
    >
      {stage === "cart" && (
        <ComplexCartStage
          onSend={() => setStage("checkout")}
          onClose={onClose}
          groupedItems={groupedItems}
        />
      )}

      {stage === "checkout" && (
        <div className={styles.checkoutContainer}>
          <div className={styles.scrollContent}>
            <ComplexOrderFields
              fieldsByCategory={fieldsByCategory}
              values={fieldValues}
              onChange={handleFieldChange}
            />
          </div>

          <ComplexOrderFooter
            phone={phone}
            comment={comment}
            onPhoneChange={setPhone}
            onCommentChange={setComment}
            onSend={handleSend}
            disabled={disabled}
            loading={loading}
            onBack={() => setStage("cart")}
            error={error} // 👈 Передаем ошибку
          />
        </div>
      )}

      {stage === "success" && (
        <div className={styles.successContainer}>
          <div className={styles.successContent}>
            <h2
              className={styles.successTitle}
              style={{ color: theme.primary }}
            >
              Заявка №{orderNumber} отправлена
            </h2>
            <p
              className={styles.successText}
              style={{ color: theme.textSecondary }}
            >
              Менеджер свяжется с вами в ближайшее время
            </p>

            <Button
              title="Перейти к заявкам"
              onClick={() => {
                onClose();
                navigate(ROUTES.COMPLEX_ORDERS);
              }}
              variant="primary"
              fullWidth
            />
            <Button
              title="Продолжить покупки"
              onClick={onClose}
              variant="primary"
              fullWidth
            />
          </div>
        </div>
      )}
    </div>
  );
}
